// Preview do checkout (§6.2) — presentational: linha do topo, logo e
// botão de ação pintados com as cores recebidas. Na wave 2 ele reage
// AO DIGITAR: o form passa os valores do useWatch.
import { useTranslation } from "react-i18next"

import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@/components/ui/avatar"

import { getInitials } from "../utils"

const panelPrefix = "pages.adminWhiteLabels"

// "" / null → undefined (não pinta; herda o neutro do container).
const toCssColor = (
  value?: string | null
): string | undefined => value || undefined

type ThemePreviewProps = {
  name: string
  logoSrc?: string | null
  colors: {
    lineBackground?: string | null
    buttonActionBackground?: string | null
    buttonActionText?: string | null
    background?: string | null
  }
}

export const ThemePreview = ({
  name,
  logoSrc,
  colors,
}: ThemePreviewProps) => {
  const { t } = useTranslation()

  return (
    <div
      data-testid="theme-preview"
      className="overflow-hidden rounded-xl border"
      style={{
        backgroundColor: toCssColor(colors.background),
      }}
    >
      <div
        className="h-2 w-full bg-muted"
        style={{
          backgroundColor: toCssColor(
            colors.lineBackground
          ),
        }}
      />
      <div className="flex flex-col items-center gap-4 px-6 py-8">
        <Avatar className="h-12 w-12 rounded-lg">
          {logoSrc && (
            <AvatarImage src={logoSrc} alt={name} />
          )}
          <AvatarFallback className="rounded-lg text-sm font-semibold">
            {getInitials(name)}
          </AvatarFallback>
        </Avatar>
        <button
          type="button"
          disabled
          className="w-full max-w-52 cursor-default rounded-md px-4 py-2 text-sm font-medium"
          style={{
            backgroundColor: toCssColor(
              colors.buttonActionBackground
            ),
            color: toCssColor(colors.buttonActionText),
          }}
        >
          {t(`${panelPrefix}.theme.previewPayNow`)}
        </button>
      </div>
    </div>
  )
}
